module.exports = __webpack_public_path__ + "img/speech-balloon.c84cc94e.png";